const state = {
    cart: null,
    cartItems: [],
    lastOrderLine: null,
    cart_uuid: null,
    cart_route: '',
    cart_currency: 'EUR',
    delivery_country_code: 'NL',
    gifts: [],
    selectedGift: null
};

const actions = {
    destroyLine(context, payload) {
        payload.cart = this.state.cart_uuid;
        return new Promise((resolve, reject) => {
            axios.delete('/api/site/cart/line/', {data: payload})
                .then(response => {
                    context.dispatch('loadCart');
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    loadCart(context) {
        return new Promise((resolve, reject) => {
            axios.post('/api/site/cart/', {
                cart: this.state.cart_uuid,
                delivery_country_code: this.state.cart.delivery_country_code
            }).then(response => {
                    context.commit('setCart', response.data.data);
                    context.commit('setGifts', response.data.data.gifts);
                    context.commit('setDeliveryCountryCode', response.data.data.delivery_country_code);
                    context.commit('setCartItems', response.data.data.items);
                    context.commit('setSelectedGift', response.data.data.gift ?? null);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updateQuantity(context, payload) {
        return new Promise((resolve, reject) => {
            payload.cart = this.state.cart_uuid;
            axios.post('/api/site/cart/line/update-quantity/', _.merge(payload, {_method: 'PUT'}))
                .then(response => {
                    context.dispatch('loadCart');
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    updateSelectedGift(context, payload) {
        context.commit('setSelectedGift', payload);

        this.dispatch('cart/addItem', {
            product_id: payload,
            is_gift: 1
        });
    },
    // updateDiscount(context, payload) {
    //     return new Promise((resolve, reject) => {
    //         axios.post('/api/portal/cart/update-discount/', {
    //             _method: 'PUT',
    //             cart_id: payload.object.id,
    //             discount: payload.discount
    //         })
    //             .then(response => {
    //                 context.dispatch('loadCart');
    //                 resolve(response);
    //             })
    //             .catch(error => {
    //                 reject(error);
    //             });
    //     });
    // },
    // updateLineDiscount(context, payload) {
    //     return new Promise((resolve, reject) => {
    //         axios.post('/api/portal/cart/line/update-discount/', {
    //             _method: 'PUT',
    //             cart_item_id: payload.object.id,
    //             discount: payload.discount
    //         })
    //             .then(response => {
    //                 context.dispatch('loadCart');
    //                 resolve(response);
    //             })
    //             .catch(error => {
    //                 reject(error);
    //             });
    //     });
    // },
    updateCountryCode(context, deliveryCountryCode) {
        return new Promise((resolve, reject) => {
            context.commit('setDeliveryCountryCode', deliveryCountryCode);
            context.dispatch('loadCart').then(response => {
                resolve(response.data.data.delivery_country_code);
            });
        });
    },
    addItem(context, payload) {
        // be sure to use the current cart_uuid (even after refresh/tabs)
        payload.cart = this.state.cart_uuid;
        return new Promise((resolve, reject) => {
            axios.post('/api/site/cart/line/', payload)
                .then(response => {
                    context.dispatch('loadCart');
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    validateDiscountCode(context, payload) {
        return new Promise((resolve, reject) => {
            payload.cart = this.state.cart_uuid;
            axios.post('/api/site/cart/validate-discount-code/', _.merge(payload, {_method: 'PUT'})).then(response => {
                context.dispatch('loadCart');
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    deleteDiscountCode(context, payload) {
        return new Promise((resolve, reject) => {
            payload.cart = this.state.cart_uuid;
            axios.post('/api/site/cart/delete-discount-code/', _.merge(payload, {_method: 'PUT'})).then(response => {
                context.dispatch('loadCart');
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    lookupAddress(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/site/cart/lookup-address/', _.merge(payload, {_method: 'POST'})).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
    validateVatNumber(context, payload) {
        return new Promise((resolve, reject) => {
            payload.cart = this.state.cart_uuid;
            axios.post('/api/site/cart/validate-vat-number/', _.merge(payload, {_method: 'PUT'})).then(response => {
                context.dispatch('loadCart');
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        })
    },
};

const mutations = {
    deleteLastOrderLine(context) {
        context.lastOrderLine = null;
    },
    setCart(context, cart) {
        context.cart = cart;
    },
    setGifts(context, gifts) {
        context.gifts = gifts;
    },
    setSelectedGift(context, gift) {
        context.selectedGift = gift;
    },
    setCartItems(context, cartItems) {
        context.cartItems = cartItems;
    },
    setLastOrderLine(context, orderLine) {
        context.lastOrderLine = orderLine;
    },
    setDeliveryCountryCode(context, deliveryCountryCode) {
        context.delivery_country_code = deliveryCountryCode;
    }
};

const getters = {};

export const cart = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};

// function setParams(payload) {
//     return {
//         params: payload
//     }
// }
//
// function setData(payload) {
//     return {
//         data: payload
//     }
// }
